var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9129 12.6204C15.5166 12.2309 14.8279 11.8995 13.8476 11.6257C14.7573 11.3519 15.3919 10.984 15.7529 10.5214C16.1138 10.0531 16.294 9.52051 16.294 8.92442C16.294 8.35862 16.1519 7.82641 15.8672 7.32739C15.5824 6.82257 15.1938 6.44509 14.7012 6.19579C14.2085 5.94026 13.3702 5.8125 12.1862 5.8125H7.23242C8.32363 5.8125 8.49268 6.54879 8.5585 6.72509C8.62986 6.89557 8.6652 7.31536 8.6652 7.98446V16.0152C8.6652 16.6843 8.62986 17.1041 8.5585 17.2746C8.49268 17.4451 8.32363 18.1872 7.23242 18.1872H12.4834C13.9467 18.1872 15.0621 17.8192 15.8291 17.0829C16.454 16.4744 16.7665 15.7049 16.7665 14.7741C16.7665 13.8918 16.4817 13.1742 15.9129 12.6204Z",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0851 11.625H9.125",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/Bold.41796ac62f7edf91a368d1b9f37e119f.svg";
export { ForwardRef as ReactComponent };